/* oxlint-disable react-doctor/rendering-hydration-mismatch-time */
import StatusChip from 'components/@extended/StatusChip';
import { RecordLink } from 'components/record-chip/RecordLink';
import React from 'react';
import { ClassifierData } from 'types/classifiers';
import { InvoiceMinDto } from 'types/invoices';
import { formatDateStringInput } from 'utils/formatDateStringInput';
import { getClassifierText } from 'utils/getTranslations';
import { getInvoiceStatusChipType } from '../../invoices/util/invoiceUtil';

type Props = {
    invoice: InvoiceMinDto;
    classifiers: Record<string, ClassifierData>;
};

const InvoiceItem: React.FC<Props> = ({ invoice, classifiers }) => {
    return (
        <div className="grid grid-cols-[auto_auto_1fr] items-center gap-2">
            <RecordLink
                className="entity-link text-fg hover:text-link w-fit no-underline hover:underline"
                to={`/invoice/${invoice.id}`}
                target="_blank"
                rel="noopener noreferrer"
                label={invoice.invoiceNumber}
                withOrigin
            />
            <div className="whitespace-nowrap">{formatDateStringInput(new Date(invoice.invoiceDate))}</div>
            <div className="justify-self-end">
                <StatusChip
                    type={getInvoiceStatusChipType(invoice.invoiceStatusTypeCode)}
                    label={getClassifierText(classifiers['INVOICE_STATUS_TYPE'], invoice.invoiceStatusTypeCode)}
                />
            </div>
        </div>
    );
};

export default InvoiceItem;
